import { useState } from "react";
import { useAuthContext } from './useAuthContext';
import Cookies from 'js-cookie';


 export const useSignup = () =>{
    const[error,setError] = useState(null)
    const [success,setSuccess] = useState(null)
    const[isLoading, setIsLoading] = useState(null)
    const { dispatch } = useAuthContext()


    const signup = async(email, password) =>{
        setIsLoading(true)
        setError(null)

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/signup`, {
                method: 'POST',
                headers: {'Content-Type':'application/json'},
                body: JSON.stringify({email, password}),
                credentials: 'include',   // let the server set the auth cookies (auto-login)
            })
            const json = await response.json()

            if(!response.ok){
                setIsLoading(false)
                setError(json.error || "Signup failed. Please try again.")
                setSuccess(null)
                return false
            }

            setIsLoading(false)

            // The server now auto-logs the user in (sets `token`/`refresh_token`
            // cookies). If so, hydrate the auth context so protected routes unlock
            // immediately — verification happens later, in-app.
            if (json.autoLogin) {
                const token = Cookies.get('token')
                dispatch({ type: 'LOGIN', payload: token })
                setSuccess("Account created! You're all set — don't forget to verify your email (check spam).")
                return true
            }

            // Fallback (server couldn't issue tokens): old verify-then-login flow.
            setSuccess("Account created! Check your email (and spam folder) to verify, then log in.")
            return true
        } catch (e) {
            setIsLoading(false)
            setError("Network error — please check your connection and try again.")
            setSuccess(null)
            return false
        }
    }

    return {signup,isLoading,error,success}
 }

 